import type { CampusInfo } from './types'

export interface CampusInfoRow {
  key: 'pocName' | 'phone' | 'deliveryWindow' | 'lunchStart' | 'parking' | 'notes'
  label: string
  value: string
}

const CAMPUS_INFO_ROWS: Array<Pick<CampusInfoRow, 'key' | 'label'>> = [
  { key: 'pocName', label: 'Point of Contact' },
  { key: 'phone', label: 'Phone' },
  { key: 'deliveryWindow', label: 'Delivery window' },
  { key: 'parking', label: 'Delivery instructions' },
  { key: 'lunchStart', label: 'Lunch start' },
  { key: 'notes', label: 'Notes' },
]

/** Rows with content, in display order — empty fields stay hidden until filled. */
export function visibleCampusInfoRows(info: CampusInfo): CampusInfoRow[] {
  return CAMPUS_INFO_ROWS.flatMap(({ key, label }) => {
    const value = info[key].trim()
    return value ? [{ key, label, value }] : []
  })
}
